import { useMutation } from '@tanstack/react-query';
import { supabase } from '../../api';

const updateGender = async (userId: string, gender: number) => {
    // Обновление gender в таблице user_profiles
    const { data: updateData, error: updateError } = await supabase
        .from('user_profiles')
        .update({ gender })
        .eq('id', userId);

    if (updateError) {
        throw new Error(updateError.message);
    }

    return updateData;
};

export default function useUpdateGender() {
    return useMutation(({ userId, gender }: { userId: string; gender: number }) => updateGender(userId, gender), {
        onSuccess: async (data) => data,
    });
}
